import PptxGenJS from 'pptxgenjs';
import IOfferASlideData from '@app/types/data/slides/IOfferASlideData';
import { defaultViewPortPadding } from '@app/services/export/ppt/variables/constants';
import { gridColWidth } from '@app/services/export/ppt/utils/gridUtils';
import { PriceTable } from '@app/services/export/ppt/classes/PriceTable';
import AbstractOfferSlideProcessor, {
	IPptOfferSlideOptions
} from '@app/services/export/ppt/slides/AbstractOfferSlideProcessor';
import PowerPointPresentation from '@app/services/export/ppt/PowerPointPresentation';

export default class PowerPointOfferASlideProcessor extends AbstractOfferSlideProcessor<IOfferASlideData> {
	public constructor(slideData: IOfferASlideData, presentation: PowerPointPresentation) {
		const options: Partial<IPptOfferSlideOptions> = {
			imageWidth: defaultViewPortPadding.horizontal + gridColWidth(5)
		};

		super(slideData, presentation, options);
	}

	public async processSlideData(): Promise<void> {
		if (this.slideData.image) {
			await this.adjustImageDimensions(this.slideData.image);
		}

		if (this.slideData.copy) {
			this.createTextSlide();
		}
		this.createTableSlide();
	}

	private createTextSlide(): void {
		this.createOfferSlideBase();
	}

	private createTableSlide(): void {
		this.updateSlideData({ copy: '' });
		const { x, y, w } = this.getAvailableSpaceRectangle();
		const offerSlideBase: PptxGenJS.Slide = this.createOfferSlideBase();

		const priceTable = new PriceTable(
			offerSlideBase,
			{
				rows: this.slideData.priceList,
				rowLabelWidth: 1.3
			},
			{ x, y, w }
		);

		priceTable.create();
	}

	protected getSlideCount(): number {
		return this.slideData.copy ? 2 : 1;
	}
}
